import { User, UserStatus } from "@/types";
import CheckIcon from "@mui/icons-material/Check";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
} from "@mui/material";
import { FC, useState } from "react";
import { sanitizeFieldRestProps, useRecordContext } from "react-admin";
import { useDeleteUser, useSetUserStatus } from "../../queries";
import { ActionProps } from "./action-field.types";

const ActionField: FC<ActionProps> = (props) => {
  const [anchorEl, setAnchorEl] = useState<EventTarget & HTMLButtonElement>();

  const user = useRecordContext<User>();
  const { setUserStatus } = useSetUserStatus({
    closeMenu: () => setAnchorEl(undefined),
  });
  const { deleteUser } = useDeleteUser();

  if (!user) return null;

  const isUserActive = user.status === UserStatus.ACTIVE;

  if (user.isDeleted) return null;

  return (
    <Stack
      {...sanitizeFieldRestProps(props)}
      onClick={(e: { stopPropagation: () => void }) => e.stopPropagation()}
    >
      <IconButton onClick={({ currentTarget }) => setAnchorEl(currentTarget)}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(undefined)}
      >
        {!isUserActive && (
          <MenuItem
            onClick={() =>
              setUserStatus({
                userId: user.id,
                status: UserStatus.ACTIVE,
              })
            }
          >
            <ListItemIcon>
              <CheckIcon />
            </ListItemIcon>
            <ListItemText primary="Activate" />
          </MenuItem>
        )}

        {isUserActive && (
          <MenuItem
            onClick={() =>
              setUserStatus({ userId: user.id, status: UserStatus.INACTIVE })
            }
          >
            <ListItemIcon>
              <CloseIcon />
            </ListItemIcon>
            <ListItemText primary="Deactivate" />
          </MenuItem>
        )}
        <MenuItem onClick={() => deleteUser({ userId: user.id })}>
          <ListItemIcon>
            <DeleteIcon />
          </ListItemIcon>
          <ListItemText primary="Delete" />
        </MenuItem>
      </Menu>
    </Stack>
  );
};

export { ActionField };
